export default __webpack_public_path__ + "static/img4-8b3f02da3fe5e8f653defd858c7a901d.jpg";